module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/appointments/appointment-types/add-appointment-type/messages/sms-template/sms-template.component.scss
// module id = ./src/app/appointments/appointment-types/add-appointment-type/messages/sms-template/sms-template.component.scss
// module chunks = main